import { RotationsplanVorlageSheet } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateRotationsplanVorlage/components/RotationsplanVorlageSheet';
import { useForm } from '@/domain/mitarbeiter/features/rotationsplan/features/UpdateRotationsplanVorlage/useForm';
import { useBerufe } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useBerufe/useBerufe';
import {
  type RotationsplanVorlageDetails,
  useRotationsplanVorlageById,
} from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanVorlageById/useRotationsplanVorlageById';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

export function UpdateRotationsplanVorlage() {
  const { vorlageId } = useParams();
  const { vorlage } = useRotationsplanVorlageById(vorlageId ?? '');

  if (!vorlage) {
    return <Navigate to="/mitarbeiter/rotationsplaene/vorlagen" replace />;
  }

  return <UpdateRotationsplanVorlageSheet vorlage={vorlage} />;
}

// eigene Komponente, damit useBerufe und useForm nur mit geladener Vorlage aufgerufen werden
function UpdateRotationsplanVorlageSheet({
  vorlage,
}: {
  vorlage: RotationsplanVorlageDetails;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { berufe } = useBerufe(vorlage.standortgruppenId);
  const { form, titelVergeben } = useForm({ vorlage, berufe });

  return (
    <RotationsplanVorlageSheet
      titel={t('domain.mitarbeiter.rotationsplan.vorlagen.updateVorlage.titel')}
      berufe={berufe}
      form={form}
      titelVergeben={titelVergeben}
      close={() =>
        navigate(`/mitarbeiter/rotationsplaene/vorlagen/${vorlage.id}`, {
          replace: true,
        })
      }
    />
  );
}
